import { OneLinkUrlGenerator } from '../../../vendor/onelink/OneLinkUrlGenerator';

export class Onelink {
    private onelink: OneLinkUrlGenerator;
    private readonly baseUrl: string;
    private readonly userAgent: string;

    constructor(onelinkBaseUrl: string, userAgent: string) {
        this.onelink = new OneLinkUrlGenerator({
            oneLinkURL: onelinkBaseUrl,
            pidKeysList: ['prtr'],
            campaignKeysList: ['cpn'],
            gclIdParam: 'gclid'

        });
        this.baseUrl = onelinkBaseUrl;
        this.userAgent = userAgent;
    }

    public setDefaultOpts(): void {
        const fbc = $.cookie('_fbc') as string;
        const fbp = $.cookie('_fbp') as string;
        this.onelink.setAfSub1('userAgent', [encodeURI(this.userAgent)]);
        this.onelink.setAfSub3('fbc', [fbc]);
        this.onelink.setAfSub4('fbp', [fbp]);
        this.onelink.setAdset('af_adset');
        this.onelink.setAd('af_ad');
        this.onelink.setChannel('af_channel');
        this.onelink.setCustomParameter('af_c_id', 'af_c_id');
        this.onelink.setCustomParameter('adgroup_id', 'adgroup_id');
        this.onelink.setCustomParameter('fbclid', 'fbclid');
        this.onelink.setCustomParameter('af_adset_id', 'af_adset_id');
    }

    public generate(): string {
        const url = this.onelink.generateUrl();
        return url ? url : this.baseUrl;
    }
}
